import { z } from 'zod';
/**
 * Mirror of `backend/src/schemas/event_settings.ts`.
 *
 * Duplicated deliberately: the backend cannot import `@event67/shared` (the
 * perf and ZAP workflows build the backend without building shared), so the two
 * copies are pinned together by `backend/tests/contracts.test.ts` instead of by
 * an import. Change one, change the other, or that test fails with a diff.
 */
export const VISIBILITY_SECTIONS = [
    'schedule',
    'speakers',
    'sponsors',
    'info',
    'attendees',
    'photos',
    'announcements',
];
export const VisibilitySectionSchema = z.enum(VISIBILITY_SECTIONS);
/**
 * Reserved ids for the placeholder rows the API serves in place of a hidden
 * section. Mirrored from the backend's business process; pinned by
 * `backend/tests/contracts.test.ts`.
 *
 * A client that wants to tell a synthesised row from a real one compares
 * against these rather than sniffing the title.
 */
export const COMING_SOON_SESSION_ID = '00000000-0000-4000-8000-000000000001';
export const COMING_SOON_SPEAKER_ID = '00000000-0000-4000-8000-000000000002';
/** Sparse: only the sections an organiser explicitly set. Unknown keys stripped. */
export const VisibilityFlagsSchema = z.object({
    schedule: z.boolean().optional(),
    speakers: z.boolean().optional(),
    sponsors: z.boolean().optional(),
    info: z.boolean().optional(),
    attendees: z.boolean().optional(),
    photos: z.boolean().optional(),
    announcements: z.boolean().optional(),
});
/** Every section present — the resolved view the API serves. */
export const ResolvedVisibilitySchema = z
    .object({
    schedule: z.boolean(),
    speakers: z.boolean(),
    sponsors: z.boolean(),
    info: z.boolean(),
    attendees: z.boolean(),
    photos: z.boolean(),
    announcements: z.boolean(),
})
    .strict();
/** The settings document — the PUT body of /v1/events/:eventId/settings. */
export const EventSettingsDocSchema = z
    .object({
    version: z.literal(1).default(1),
    visibility: VisibilityFlagsSchema.default({}),
})
    .strict();
export const ComingSoonCopySchema = z
    .object({
    title: z.string().min(1),
    body: z.string().min(1),
})
    .strict();
/** `data` of GET/PUT /v1/events/:eventId/settings. */
export const ResolvedEventSettingsSchema = z
    .object({
    version: z.literal(1),
    visibility: ResolvedVisibilitySchema,
})
    .strict();
//# sourceMappingURL=event_settings.js.map